/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import { Block } from "src/classes/block";
import { BasePlate } from "src/classes/plate/BasePlate/BasePlate";
import { Plate } from "src/classes/plate/Plate";
import { ConnectMenu } from "src/components/Shared/ConnectMenu";
import { IconButton } from "src/components/UI/Buttons/IconButtons/IconButton";
import { Connect as ConnectIcon } from "src/components/UI/Icons";

interface Props {
  block: Block | null;
  plate: Plate | BasePlate | null;
  menuOpen: boolean;
  setMenuOpen: (open: boolean) => void;
  styles?: React.CSSProperties;
  id?: string;
}
export function ConnectButton({ block, plate, menuOpen, setMenuOpen, id, styles }: Props) {
  return (
    <div style={{ position: "relative", width: "100%", height: "100%" }}>
      <IconButton
        isSelected={menuOpen}
        handleClick={() => setMenuOpen(true)}
        tooltipText="Add to plate"
        id={id}
        styles={styles}
      >
        <ConnectIcon />
      </IconButton>
      {menuOpen && (
        <ConnectMenu block={block} plate={plate} closeMenu={() => setMenuOpen(false)} blockMouseEvents={true} />
      )}
    </div>
  );
}
